import { request } from '../request'
const baseUrl = process.env.VUE_APP_BASEURL_USER
// 购买合约
export const addContract = (data) => {
  const url = baseUrl + '/api/v1/user/subscriptions/pre-payment'
  // const url = baseUrl + '/api/v1/user/subscriptions/payment'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data
  })
}
// 个人中心-合约详情
export const getContractDetail = () => {
  const url = baseUrl + '/api/v1/user/subscriptions/userDetail'
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url,
  })
}
// 套餐与付费方式
export const getPackageContract = () => {
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: baseUrl + '/api/v1/user/combo/prices',
  })
}

// 获取账号信息
export const getUserInfo = () => {
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: baseUrl + '/api/v1/user/accounts/info',
  })
}
// 更新账号信息 
export const UpdateUserInfoConfig = (data) => {
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: baseUrl + '/api/v1/user/accounts/updateUserConfig',
    data
  })
}
// 获取账号验证信息
export const getUserInfoAuth = () => {
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: baseUrl + '/api/v1/user/account-valid/info',
  })
}
// 发送手机验证码
export const sendPhoneCode = (data) => {
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: baseUrl + '/api/v1/user/ocean/sms/phone/send',
    data
  })
}
// 发送邮箱验证码
export const sendEmailCode = (data) => {
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: baseUrl + `/api/v1/user/ocean/sms/verify-email-code?mark_id=${data.markId}`
  })
}
// 验证手机号
export const validPhone = (data) => {
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: baseUrl + '/api/v1/user/account-valid/phone',
    data
  })
}

// 验证邮箱
export const validEmail = (data) => {
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: baseUrl + `/api/v1/user/account-valid/email`,
    data
  })
}

export const getUserSystem = params => {
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: baseUrl + `/api/v1/user/accounts/merchant-system-status`,
    params
  })
}
// 获取绑卡clientSecret
export const getBindContract = (data) => {
  const url = baseUrl + '/api/v1/user/credit-cards/setup-intent'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data
  })
}
// 获取用户信用卡列表
export const getCardsList = (data) => {
  const url = baseUrl + '/api/v1/user/credit-cards/list'
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url,
    data
  })
}
// 绑定成功
export const bindCompelete = (data) => {
  const url = baseUrl + '/api/v1/user/credit-cards'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data
  })
}
// 设置支付卡
export const setCardDefault = (data) => {
  const url = baseUrl + '/api/v1/user/credit-cards/set-default'
  return request({
    headers: { systemId: 6 },
    method: 'put',
    url: url,
    data
  })
}
// 解绑
export const deleteCard = (id) => {
  const url = baseUrl + `/api/v1/user/credit-cards/${id}`
  return request({
    headers: { systemId: 6 },
    method: 'delete',
    url: url,
  })
}
// 合约支付
export const postPayment = (data) => {
  const url = baseUrl + '/api/v1/user/subscriptions/payment'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data,
    notMsg: true
  })
}
// 用户套餐列表
export const getSubscriptionsList = (params) => {
  const url = baseUrl + '/api/v1/user/subscriptions/list'
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url,
    params
  })
}
// 合约详情
export const getSubscriptionDetail = (id) => {
  const url = baseUrl + `/api/v1/user/subscriptions/detail/${id}`
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url,
  })
}
// 校验优惠券
export const checkCouponCode = data => {
  const url = baseUrl + '/api/v1/user/coupon/check-code'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data,
    notMsg: true
  })
}
// 查询支付详情
export const checkPayDetail = (subscriptionNo) => {
  const url = baseUrl + `/api/v1/user/subscriptions/pay-detail/${subscriptionNo}`
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url,
  })
}
// 用户已订阅套餐
export const getUserSubscribe = () => {
  const url = baseUrl + '/api/v1/user/subscriptions/user-subscribe'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
  })
}
// 开启 变更订阅
export const getChangeSubscribe = data => {
  const url = baseUrl + '/api/v1/user/subscriptions/subscribe'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data
  })
}
// 取消订阅套餐
export const postCancleSubscribe = id => {
  const url = baseUrl + `/api/v1/user/subscriptions/cancel/${id}`
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
  })
}
// 绑卡失败记录
export const bindCardFail = data => {
  const url = baseUrl + '/api/v1/user/subscription-monitor/card-error'
  return request({
    headers: { systemId: 6 },
    method: 'post',
    url: url,
    data
  })
}

// 获取优惠券配置
export const getCouponSetting = () => {
  const url = baseUrl + '/api/v1/user/charge-config/coupon-config'
  return request({
    headers: { systemId: 6 },
    method: 'get',
    url: url
  })
}

// 获取订阅套餐剩余天数
export const getSubscriptionsRemainDay = () => {
  const url = baseUrl + `/api/v1/user/subscriptions/remain-days`
  return request({
    headers: { systemId: 6 },
    method: 'put',
    url: url,
  })
}
// 升级套餐
export const upgradeSubscriptions = (data) => {
  const url = baseUrl + `/api/v1/user/subscriptions/upgrade`
  return request({
    headers: { systemId: 6 },
    method: 'put',
    url: url,
    data,
    notMsg: true
  })
}